import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = 'G-P7GK42M5J1'; // Your GA4 Measurement ID

/**
 * GATracker component ensures that a page_view event is manually fired 
 * every time the React Router location changes, as required for accurate 
 * tracking in Single Page Applications (SPAs).
 */
const GATracker = () => {
    const location = useLocation();

    // This effect runs every time the URL path or search parameters change.
    useEffect(() => {
        // We check for window.gtag because the script loads asynchronously in index.html.
        if (window.gtag) {
            // Send the 'config' command, which triggers a page_view event 
            // for the current path, ensuring internal navigation is tracked.
            window.gtag('config', GA_TRACKING_ID, { 
                'page_path': location.pathname + location.search,
                'send_page_view': true 
            });
        }
    }, [location.pathname, location.search]); 

    return null;
};

// 🛑 CRITICAL FIX: Use named export to match the import { GATracker } from "../components/GATracker" in App.js
export { GATracker };